import React, {Component} from 'react';
import {connect} from 'react-redux';
import Dashboard from '../components/dashboard';
import axios from '../axios'
import Moment from 'react-moment';
import {Redirect} from 'react-router-dom';

import * as actions from '../store/actions/index'

class DashboardPage extends Component {
    state = {
        registeredDate: null,
        redirect: false
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.fetchLoginLogs();
        this.props.fetchRegisteredForms();
        this.props.fetchUserNumber();

        const token = 'Bearer ' + localStorage.getItem('token');
        axios.get(`http://localhost:7000/admin/checkadmin`, {headers: {"Authorization": token}})
            .then(({data}) => {
                //console.log(data);
                if (data.status === 1) {
                    this.setState({
                        redirect: false
                    })
                } else {
                    this.setState({
                        redirect: true
                    })
                }
            })
            .catch(err => {
                console.log(err)
            })

        axios.get('admin/lastregister/')
            .then(response => {
                //console.log("response.data.message[0].creation_date " + response.data.message[0].creation_date);
                this.setState({registeredDate: response.data.message[0].creation_date})
            })
            .catch(err => {
                console.log(err);
            })
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to="/"/>
        }
        const final_date = <Moment format="DD-MM-YYYY H:mm:ss">{this.state.registeredDate}</Moment>;

        //console.log(this.props.loginLogs.length);
        //console.log(this.props.registered_forms);
        //console.log(this.props.user_number);
        //console.log(this.state.registeredDate);

        return (
            <Dashboard
                logsNumber={this.props.loginLogs.length}
                registeredFormsNumber={this.props.registered_forms}
                registeredUsersNumber={this.props.user_number}
                registerDate={final_date}
            />
        )
    }
}

const mapStateToProps = state => {
    return {
        loginLogs: state.admin.loginLogs,
        registered_forms: state.general_indicators.registered_forms,
        user_number: state.general_indicators.user_number
    };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchLoginLogs: () => dispatch(actions.loginLogs()),
        fetchRegisteredForms: () => dispatch(actions.fetchRegisteredFormsNumber()),
        fetchUserNumber: () => dispatch(actions.fetchUserNumber())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage);



// WEBPACK FOOTER //
// ./src/containers/Dashboard.js